import './layout.css';

interface Props {
    pageTitle?: string;
}
const Header = ({ pageTitle }: Props) => {
    return (
        <header className="header">
            <h3 className="page-title">{pageTitle ? pageTitle : ''}</h3>
        </header>
    );
};

export default Header;
